import { ApprovedIcon } from '@/assets/icons/info-icons/approved';
import styled from 'styled-components';
import { themeVar } from '@/styles/theme';

export const updateWizardSteps = (
  direction: 'prev' | 'next',
  wizardSteps: { name: string; status: string }[],
  handleWizardSteps: (steps: { name: string; status: string }[]) => void
) => {
  const currentStepIndex = wizardSteps.findIndex((step) => step.status === 'IN_PROGRESS');
  if (direction === 'prev' && currentStepIndex === 0) return;
  if (direction === 'next' && currentStepIndex === wizardSteps.length - 1) return;

  const updatedWizardSteps = wizardSteps.map((step, index) => {
    if (currentStepIndex === index) {
      return { ...step, status: direction === 'prev' ? 'NOT_STARTED' : 'COMPLETED' };
    }
    if (direction === 'prev' && currentStepIndex - 1 === index) {
      return { ...step, status: 'IN_PROGRESS' };
    }
    if (direction === 'next' && currentStepIndex + 1 === index) {
      return { ...step, status: 'IN_PROGRESS' };
    }

    return step;
  });

  handleWizardSteps(updatedWizardSteps);
};

interface WizardProgressBarProps {
  steps: { name: string; status: string }[];
}

export const WizardProgressBar = ({ steps }: WizardProgressBarProps) => {
  return (
    <ProgressBarWrapper>
      <ProgressBar>
        {steps.map((step) => (
          <StepItemWrapper key={step.name}>
            {step.status === 'COMPLETED' ? (
              <ApprovedIcon fill={themeVar('context.success')} />
            ) : (
              <>
                <StepItem isStepInProgress={step.status === 'IN_PROGRESS'}>{step.status === 'IN_PROGRESS' && <Circle />}</StepItem>
              </>
            )}
          </StepItemWrapper>
        ))}
      </ProgressBar>
      <StepName>{steps.find((step) => step.status === 'IN_PROGRESS')?.name || ''}</StepName>
    </ProgressBarWrapper>
  );
};

const ProgressBarWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 30px;
`;

const ProgressBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: max-content;
  padding-bottom: 10px;
  border-bottom: 1px solid ${themeVar('border.base')};
`;

const StepItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;

const StepItem = styled.div<{ isStepInProgress: boolean }>`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 2px solid ${({ isStepInProgress }) => (isStepInProgress ? themeVar('action.hover') : themeVar('layer.2'))};
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${themeVar('layer.base')};
`;

const StepName = styled.p`
  color: ${themeVar('font.strong')};
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
`;

const Circle = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: ${themeVar('action.hover')};
`;
